module.exports = __webpack_public_path__ + "img/welcomes-preview-text-vip-white.71f42772.png";